import { Prisma } from "@prisma/client";
import { BuyableItemEvent, BuyableItemHandler } from "../buyable-item.types";

type PartialExportExhibitorsModuleBuyableItem = {
  exportExhibitorsModuleEvent?: { id: string } | null;
};

type ExportExhibitorsModuleBuyableItem = {
  exportExhibitorsModuleEvent: { id: string };
};

type ExportExhibitorsModuleWithEvent = {
  exportExhibitorsModuleEvent: BuyableItemEvent;
};

const GROUP_KEY_PREFIX = "exportExhibitorsModule";

export const ExportExhibitorsModuleBuyableItemHandler = {
  displayName: "Export du module exposants",
  accounting: {
    generalAccountCode: "706507",
    invoiceLabel: "Export du module exposants",
  },

  getEvent(item: ExportExhibitorsModuleWithEvent): BuyableItemEvent {
    return item.exportExhibitorsModuleEvent;
  },

  isValid(item: PartialExportExhibitorsModuleBuyableItem): boolean {
    return !!item.exportExhibitorsModuleEvent?.id;
  },

  findEquivalent(item: PartialExportExhibitorsModuleBuyableItem): Prisma.BuyableItemWhereInput {
    return {
      exportExhibitorsModuleEvent: {
        id: item.exportExhibitorsModuleEvent?.id,
      },
    };
  },

  create({
    exportExhibitorsModuleEvent,
  }: ExportExhibitorsModuleBuyableItem): Omit<Prisma.BuyableItemCreateInput, "buyableType"> {
    return {
      exportExhibitorsModuleEvent: {
        connect: {
          id: exportExhibitorsModuleEvent.id,
        },
      },
    };
  },

  parseGroupKeyAsWhere(groupKey: string): Prisma.BuyableItemWhereInput {
    if (!ExportExhibitorsModuleBuyableItemHandler.isGroupKey(groupKey)) {
      throw new Error(`Invalid group key for export exhibitors module: ${groupKey}`);
    }

    const [, eventId] = groupKey.split("|");
    return {
      exportExhibitorsModuleEvent: {
        id: eventId,
      },
    };
  },

  isGroupKey(groupKey: string): boolean {
    return groupKey.startsWith(`${GROUP_KEY_PREFIX}|`);
  },

  getGroupKey(item: PartialExportExhibitorsModuleBuyableItem): string {
    const eventId = item.exportExhibitorsModuleEvent?.id;
    if (!eventId) {
      throw new Error("Cannot get group key for invalid exportExhibitorsModule item");
    }
    return `${GROUP_KEY_PREFIX}|${eventId}`;
  },

  getPricingQuery(): Prisma.PricingFindFirstArgs {
    return {
      where: {
        backofficePrestation: {
          type: "exportExhibitorsModule",
        },
      },
    };
  },

  getEventSearchFilter(searchText: string): Prisma.BuyableItemWhereInput {
    return {
      exportExhibitorsModuleEvent: {
        name: { contains: searchText, mode: "insensitive" },
      },
    };
  },
} as const satisfies BuyableItemHandler;
